function fetchScript(url, params, options) {
  options = options || {};
  fetch(url + '?' + new URLSearchParams(params).toString(), {
    headers: {
      'Accept': 'text/javascript, application/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  }).then(function(res) {
    return Promise.all([res, res.text()]);
  }).then(function(result) {
    var res = result[0];
    var js = result[1];
    var contentType = (res.headers.get('content-type') || '').toLowerCase();
    if (!res.ok || contentType.indexOf('javascript') === -1) {
      throw new Error('Expected JavaScript from ' + res.url + ' but received ' + (contentType || 'unknown content type'));
    }
    var script = document.createElement('script');
    // Without a sourceURL, browsers attribute inline-script errors to the last
    // loaded external script (often google_analytics.js), making Bugsnag
    // stack traces misleading. This tells the browser the real source.
    script.textContent = js + '\n//# sourceURL=' + url;
    document.head.appendChild(script);
    document.head.removeChild(script);
  }).catch(function(error) {
    if (typeof options.onFailure === "function") options.onFailure(error);
    console.error(error);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll(".ebay-listing-form").forEach(function(f) { f.submit(); });
  document.querySelectorAll(".tcgplayer-price-widget-form").forEach(function(f) { f.submit(); });
  document.querySelectorAll(".cardkingdom-price-widget-form").forEach(function(f) { f.submit(); });

  document.addEventListener('show.bs.modal', function(e) {
    var el = e.target;
    if (!el.classList.contains('logged_in-modal')) return;
    if (document.getElementById("logged_in")) return;
    e.preventDefault();
    var id = el.getAttribute('id');
    var url = window.location.href.split("#")[0] + "#" + id;
    var loginOverride = document.querySelector(".login-override_origin");
    if (loginOverride) loginOverride.value = url;
    bootstrap.Modal.getOrCreateInstance(document.querySelector('#login-modal')).show();
  });

  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.matches('.form-submit-on-change')) return;
    e.target.closest("form").submit();
  });
});

function initializeCardPriceHistoryComponent(tabId, cardId, priceType) {
  var type = "";
  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    if (!tabEl.closest('#' + tabId)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    // Use getElementById so numeric IDs (e.g. "413-tab-online") work — those
    // start with a digit and are invalid as CSS selectors for querySelector.
    var tabElId = hash && hash.charAt(0) === '#' ? hash.slice(1) : hash;
    var tab = tabElId ? document.getElementById(tabElId) : null;
    if (!tab) return;
    if (tab.dataset.priceHistoryComponent && !tab.dataset.loaded && !tab.dataset.loading) {
      type = tab.dataset.type;
      tab.dataset.loading = "true";
      fetchScript('/price_history_component', {
        card_id: cardId,
        selector: hash,
        type: type,
        price_type: priceType,
      }, {
        onFailure: function() {
          delete tab.dataset.loading;
        }
      });
    }
  });
}
window.initializeCardPriceHistoryComponent = initializeCardPriceHistoryComponent;
